import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAllTeams } from '../../data/team-dao';
export const fetchTeamsAsyncThunk = createAsyncThunk('teams/fetch', async () => await getAllTeams());